import { createFileRoute } from '@tanstack/react-router'
import { ProfilePage } from '@/features/employee-portal/pages/ProfilePage'

export const Route = createFileRoute('/employee/profile/')({
  component: ProfilePage,
})
